import { Alert, Icons, ExternalLink, Typography } from '@cast/design-system';

import { CloseableAlert } from 'components/alerts';
import { PreparedWorkload } from 'features/workload-optimization';

import { getDocsLink } from '@cast/utils';

export const HpaUnsupportedOwnershipBanner = ({
  workload,
}: {
  workload: PreparedWorkload;
}) => {
  return (
    <CloseableAlert
      testId="hpa-unsupported-ownership-banner"
      size="small"
      variant="filled"
      color="advisory"
      icon={<Icons.XCircle size={20} />}
      title="Cannot transfer HPA ownership"
      closeable={`hpa-unsupported-ownership-banner-${workload.id}`}
      Component={Alert}
    >
      <Typography variant="P12R">
        This workload&apos;s HPA uses features not supported by scaling
        policies.{' '}
        <ExternalLink link={getDocsLink('docs_woop_hpa')} noIcon>
          Documentation
        </ExternalLink>
        .
      </Typography>
    </CloseableAlert>
  );
};
